/* mate Bewerten-Seite: progressives Formular, Foto-Vorschau, Absenden an n8n. */
(function () {
  'use strict';
  var root = document.querySelector('[data-section-type="mate-review-form"]');
  if (!root) return;
  var form = root.querySelector('[data-mrf-form]');
  var endpoint = root.dataset.mrfEndpoint;
  var maxFiles = parseInt(root.dataset.mrfMaxFiles || '3', 10);
  var params = new URLSearchParams(location.search);
  var token = params.get('t') || '';
  var productHandle = params.get('product') || '';
  var files = [];

  root.querySelector('[data-mrf-token]').value = token;
  root.querySelector('[data-mrf-product]').value = productHandle;
  if (!token) { form.hidden = true; root.querySelector('[data-mrf-noinvite]').hidden = false; return; }

  /* Skalen je Produktart: Akku nur bei der Zahnbürste, Putzleistung bei Zahnbürste und Köpfen */
  function applyAttrs(p) {
    var hay = [p.title || '', p.handle || '', productHandle, p.type || ''].join(' ').toLowerCase();
    var brush = /schallzahnb|zahnb(ü|u)rste/.test(hay) && !/wechselk|aufsatz|k(ö|o)pfe/.test(hay);
    var heads = /wechselk|aufsatz|k(ö|o)pfe/.test(hay);
    var show = { produktqualitaet: true, putzleistung: brush || heads, akkuleistung: brush };
    root.querySelectorAll('[data-mrf-attr]').forEach(function (el) {
      var on = !!show[el.dataset.mrfAttr];
      el.hidden = !on;
      var inp = el.querySelector('input'); if (inp) inp.disabled = !on;
    });
  }

  /* Produktkarte aus dem Shop laden (kein API-Key nötig) */
  if (productHandle) {
    fetch('/products/' + encodeURIComponent(productHandle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return;
      var card = root.querySelector('[data-mrf-product-card]');
      card.querySelector('[data-mrf-product-name]').textContent = p.title;
      var img = card.querySelector('[data-mrf-product-img]');
      if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; } else { img.remove(); }
      card.hidden = false;
      var t = root.querySelector('[data-mrf-title]');
      var brush = /schallzahnb/i.test(p.title);
      if (t && /mate\?$/.test(t.textContent) && !brush) t.textContent = 'Wie gefällt dir ' + p.title.replace(/\s*\|.*$/, '') + '?';
      applyAttrs(p);
    }).catch(function () {});
  }

  /* Schritte nacheinander öffnen */
  var order = ['stars', 'attrs', 'text', 'about'];
  function reveal(step) {
    var idx = order.indexOf(step);
    order.slice(0, idx + 1).forEach(function (s) { root.querySelector('[data-mrf-step="' + s + '"]').hidden = false; });
  }

  /* Sterne */
  var hints = { 1: 'Das tut uns leid. Erzähl uns bitte, was schiefging.', 2: 'Danke für deine Ehrlichkeit.', 3: 'Okay, aber nicht überzeugt. Was fehlt?', 4: 'Fast perfekt. Was hat gefehlt?', 5: 'Das freut uns riesig!' };
  var starInputs = root.querySelectorAll('input[name="rating"]');
  var stars = root.querySelectorAll('.mrf__star');
  function paintStars(v) {
    stars.forEach(function (l, i) { l.classList.toggle('is-on', i < v); });
    root.querySelector('[data-mrf-star-hint]').textContent = hints[v] || '';
    root.querySelector('[data-mrf-feedback]').hidden = !(v && v <= 3);
  }
  starInputs.forEach(function (inp) {
    inp.addEventListener('change', function () { paintStars(parseInt(inp.value, 10)); reveal('about'); });
  });
  stars.forEach(function (l, i) {
    l.addEventListener('mouseenter', function () { stars.forEach(function (x, j) { x.classList.toggle('is-hover', j <= i); }); });
    l.addEventListener('mouseleave', function () { stars.forEach(function (x) { x.classList.remove('is-hover'); }); });
  });
  var pre = parseInt(params.get('stars') || '0', 10);
  if (pre >= 1 && pre <= 5) { starInputs[pre - 1].checked = true; paintStars(pre); reveal('about'); }

  /* Slider: 0 = keine Angabe */
  root.querySelectorAll('[data-mrf-range]').forEach(function (r) {
    var out = root.querySelector('[data-mrf-out="' + r.name + '"]');
    function upd() { var v = parseInt(r.value, 10); out.textContent = v === 0 ? 'keine Angabe' : v + ' von 5'; }
    r.addEventListener('input', upd); upd();
  });

  /* Fotos */
  var fileInput = root.querySelector('[data-mrf-files]');
  var previews = root.querySelector('[data-mrf-previews]');
  function renderPreviews() {
    previews.innerHTML = '';
    files.forEach(function (f, i) {
      var li = document.createElement('li');
      var img = document.createElement('img'); img.src = URL.createObjectURL(f); img.alt = '';
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Foto entfernen'); b.textContent = '×';
      b.addEventListener('click', function () { files.splice(i, 1); renderPreviews(); });
      li.appendChild(img); li.appendChild(b); previews.appendChild(li);
    });
  }
  if (fileInput) fileInput.addEventListener('change', function () {
    Array.prototype.forEach.call(fileInput.files, function (f) {
      if (files.length >= maxFiles) return;
      if (f.type.indexOf('image/') !== 0) { showError('„' + f.name + '“ ist kein Foto.'); return; }
      if (f.size > 25 * 1024 * 1024) { showError('„' + f.name + '“ ist größer als 25 MB.'); return; }
      files.push(f);
    });
    fileInput.value = ''; renderPreviews();
  });

  function showError(msg) { var e = root.querySelector('[data-mrf-error]'); e.textContent = msg; e.hidden = !msg; if (msg) e.scrollIntoView({ block: 'center', behavior: 'smooth' }); }

  /* Absenden */
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    showError('');
    var rating = form.querySelector('input[name="rating"]:checked');
    if (!rating) { showError('Bitte wähle zuerst deine Sterne.'); return; }
    if (!form.consent.checked) { showError('Bitte bestätige die Veröffentlichung.'); return; }
    if (!endpoint) { showError('Das Formular ist noch nicht verbunden. Bitte versuch es später erneut.'); return; }
    var fd = new FormData(form);
    fd.delete('media');
    files.forEach(function (f, i) { fd.append('media_' + i, f, f.name); });
    fd.append('media_count', String(files.length));
    fd.append('page_url', location.href);
    var btn = root.querySelector('[data-mrf-submit]');
    btn.disabled = true; btn.textContent = 'Wird gesendet …';
    fetch(endpoint, { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.ok === false) { throw new Error(res.j.message || 'Senden fehlgeschlagen. Bitte versuch es gleich noch einmal.'); }
        form.hidden = true;
        root.querySelector('[data-mrf-done]').hidden = false;
        if (res.j.next_product_handle && res.j.next_token) {
          root.querySelector('[data-mrf-next-product]').hidden = false;
          var a = root.querySelector('[data-mrf-next-link]');
          a.href = location.pathname + '?t=' + encodeURIComponent(res.j.next_token) + '&product=' + encodeURIComponent(res.j.next_product_handle);
          a.textContent = 'Auch „' + (res.j.next_product_title || 'das zweite Produkt') + '“ bewerten';
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function (e) { showError(e.message); btn.disabled = false; btn.textContent = 'Bewertung absenden'; });
  });
})();
